module.exports = __webpack_public_path__ + "static/media/b4.a67eb0d3.jpg";